import { Component } from 'preact';
import style from './style.scss';
import { Link, route } from 'preact-router';
import { API } from '../API';
import { Event } from '../../utils/events';

class Footer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			linkDetails : []
		};
	}
	componentWillReceiveProps(nextProps) {}

	componentDidMount() {
		API.getFooterDetails()
			.then((res) => {
				if (res && res.length > 0) {
					this.setState({
						linkDetails : res
					});
				}
			})
			.catch((error) => console.error(error));
	}

	render() {
		const { linkDetails } = this.state;
		return (
			<footer>
				<div class={style.footerContainer}>
					<div class={style.copyrightContainer}>
						<p class={style.buildingVisions}>
							EMPOWERING
							<br style="display: block !important;" />
							CONSUMER
							<br style="display: block !important;" />
							CULTURE
							{/* BUILDING <br />
              VISIONS */}
						</p>
						<div class={style.copyright}>
							<p>&copy; GDP Venture All Rights Reserved.</p>
						</div>
					</div>
					<div class={style.corporateContainer}>
						<p>Corporate</p>
						<ul>
							<li>
								<a
									href="https://venture.dev365.gdpventure.com/#/about"
									target="_blank"
									onClick={() => {
										Event('Footer Navigation to About', 'About Page', 'About Component');
									}}
								>
									About
								</a>
							</li>
							<li>
								<a
									href="https://venture.dev365.gdpventure.com/#/?=portfolio"
									target="_blank"
									onClick={() => {
										Event(
											'Footer Navigation to Portfolio',
											'Portfolio Page',
											'Portfolio Component'
										);
									}}
								>
									Portfolio
								</a>
							</li>

							<li>
								<a
									href="https://venture.dev365.gdpventure.com/#/news"
									target="_blank"
									onClick={() => {
										Event('Footer Navigation to News', 'News Page', 'News Component');
									}}
								>
									Stories
								</a>
							</li>
							<li>
								<a
									href="https://venture.dev365.gdpventure.com/#/jobs"
									target="_blank"
									onClick={() => {
										Event('Footer Navigation to Jobs', 'Jobs Page', 'Jobs Component');
									}}
								>
									Jobs
								</a>
							</li>
							<li>
								<a
									href="https://venture.dev365.gdpventure.com/#/legal"
									target="_blank"
									onClick={() => {
										Event('Footer Navigation to Venture Site', 'Contact Page', 'Contact Component');
									}}
								>
									Legal
								</a>
							</li>
							<li>
								<a
									href="https://venture.dev365.gdpventure.com/#/contact"
									target="_blank"
									onClick={() => {
										Event('Footer Navigation to Venture Site', 'Contact Page', 'Contact Component');
									}}
								>
									Contact
								</a>
							</li>
							{/* {linkDetails.length > 0 &&
							linkDetails[0].field_brand_assets && (
								<li>
									<a
										href={linkDetails[0].field_brand_assets}
										onClick={() => {
											Event(
												'Footer Navigation to Brand Assets',
												'Brand Assets Page',
												'Brand Assets'
											);
										}}
									>
										Brand Assets
									</a>
								</li>
							)} */}
						</ul>
					</div>
					<div class={style.connectContainer}>
						<p style="font-weight: lighter">Connect</p>
						<ul>
							<li>
								<Link
									onClick={() => {
										Event('Footer Navigation to Collabs', 'Collabs Page', 'Footer Component');
										window.location.replace(window.location.origin + '#/collabs');
										window.scrollTo(0, 0);
									}}
								>
									Collabs
								</Link>
							</li>
							<li>
								<Link
									onClick={() => {
										Event('Footer Navigation to Insights', 'Insights Page', 'Footer Component');

										window.location.replace(window.location.origin + '#/insights');
										window.scrollTo(0, 0);
									}}
								>
									Insights
								</Link>
							</li>
							<li>
								<Link
									onClick={() => {
										Event('Footer Navigation to Audience', 'Audience Page', 'Footer Component');
										window.location.replace(window.location.origin + '#/audiences');
										window.scrollTo(0, 0);
									}}
								>
									Audiences
								</Link>
							</li>
							<li>
								<Link
									onClick={() => {
										Event('Footer Navigation to Get In Touch', 'Form Page', 'Footer Component');
										window.location.replace(window.location.origin + '#/getintouch');
										window.scrollTo(0, 0);
									}}
								>
									TALK TO US
								</Link>
							</li>
						</ul>
					</div>
					<div class={style.container}>
						<p>Follow us</p>
						<div class={style.socialContainer}>
							<a
								href={
									linkDetails.length > 0 && linkDetails[0].field_follow_fb ? (
										linkDetails[0].field_follow_fb
									) : (
										''
									)
								}
								target="blank"
							>
								<img src="/assets/images/facebook.png" />
							</a>
							<a
								href={
									linkDetails.length > 0 && linkDetails[0].field_follow_twitter ? (
										linkDetails[0].field_follow_twitter
									) : (
										''
									)
								}
								target="blank"
							>
								<img src="/assets/images/twitter.png" />
							</a>

							<a
								href={
									linkDetails.length > 0 && linkDetails[0].field_follow_instagram ? (
										linkDetails[0].field_follow_instagram
									) : (
										''
									)
								}
								target="blank"
							>
								<img src="/assets/images/Instagram.png" />
							</a>
							<a
								href={
									linkDetails.length > 0 && linkDetails[0].field_follow_youtube ? (
										linkDetails[0].field_follow_youtube
									) : (
										''
									)
								}
								target="blank"
							>
								<img src="/assets/images/yt_icon_mono_dark.png" />
							</a>
						</div>
					</div>
					<div class={style.copyrightmobile}>
						<p>&copy; GDP Venture All Rights Reserved.</p>
					</div>
				</div>
			</footer>
		);
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./components/footer/index.js